<template>
  <card-item card="item_customer" :tabs="tabs" :activeTab="activeTab" :id="id" :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key:'information_card',
          component: () => import("./Info"),
        },
          {
          title: "Сменить пароль",
                    key:'change_password',
          component: () => import("./Password"),
        },
      ],
      activeTab: 0,

           infoKeys:[
        {
          key: 'full_name',
          title:'ФИО'
        },
        {
          key: 'phone',
          title:'Номер телефона'
        },
        ]
    };
  },
};
</script>